import { render } from "./CategoryServiceHealthAndWelfare.vue?vue&type=template&id=0e73678c&scoped=true&ts=true"
import script from "./CategoryServiceHealthAndWelfare.vue?vue&type=script&lang=ts"
export * from "./CategoryServiceHealthAndWelfare.vue?vue&type=script&lang=ts"

import "./CategoryServiceHealthAndWelfare.vue?vue&type=style&index=0&id=0e73678c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e73678c"]])

export default __exports__